/* Components */
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
import {useEffect, useState} from "react";
import {deleteProductFromDb, getProductList, setProductEnabled} from "../../../api/admin/productReq";
import FormProduct from "../../../forms/admin/FormProduct";
import ProductActions from "../../../components/common/admin/ProductActions";
import PagingDashboard from "../../../components/common/dashboard/PagingDashboard";
import usePager from "../../../hooks/usePager";
import {getErrorListFromValidation, removeErrorList} from "../../../helper/tools";

export default function ProductsServices() {

    const { auth } = useAuth();
    const token = auth.token;
    const { productList, setProductList, setProductInfos } = useData();
    const { currentPage, setCurrentPage, itemsPerPage, setTotalPages } = usePager();
    const sources = "fa fa-euro-sign";
    const [ showModal, setShowModal ] = useState(false);
    const [ totalItems, setTotalItems ] = useState();

    const apiProductList =  async () => {
        const response = await getProductList(token, currentPage, itemsPerPage);
        setProductList(response?.productList)
        setTotalItems(response?.totalItems)
    };

    useEffect(() => {
        setCurrentPage(1)
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [ itemsPerPage, totalItems ]);

    useEffect(() => {
        apiProductList()
    },[ currentPage, itemsPerPage ]);

    useEffect(() => {
        if (productList.length < 1) {
            apiProductList()
        }
    }, [ productList ]);

    const handleProductEnable = async (e) => {
        e.preventDefault();
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'un produit.");
        } else {
            const productId = parseInt(e.currentTarget.getAttribute("id"));
            const currentIsEnabled = e.currentTarget.classList.contains("fa-eye");

            if (currentIsEnabled) {
                let body = {
                    "productEnabled": true,
                    "productId": productId,
                }
                alert("Vous venez de désactiver ce produit.");
                await setProductEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            apiProductList()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            } else {
                let body = {
                    "productEnabled": false,
                    "productId": productId,
                }
                alert("Vous venez d'activer ce produit.");
                await setProductEnabled(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            apiProductList()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
        }
    };

    const handleDeleteProduct = (id) => {
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour supprimer définitivement un produit.");
        } else {
            if (window.confirm("Êtes-vous sûr de vouloir supprimer définitivement ce produit ?")) {
                const body = {
                    "productId": parseInt(id),
                }
                return (
                    deleteProductFromDb(token, body)
                        .then((response) => {
                            response.error ? alert("Le produit n'a pas pu être supprimé.") : alert("Le produit a bien été supprimé.")
                            apiProductList()
                        })
                )
            }
        }
    }

    const handleFormProductModal = (prodId) => {
        setProductInfos(productList.find(product => product?.id === prodId));
        setShowModal(true);
    }

    return (
        <main className="admin">
            <Header
                parent="Administration"
                location="Produits facturables"
                slug={`/admin/accueil`}
            />
            <div className="column">
                { showModal &&
                    <div className="modal product">
                        <FormProduct apiProductList={apiProductList} setShowModal={setShowModal} legend="Modification d'un produit"/>
                    </div>
                }
                    <div className="content-container">
                        <Icon source={sources} color="blue" span="Prix des produits facturables"/>
                        <ProductActions apiProductList={apiProductList} setShowModal={setShowModal}/>
                        <div className="dashboard">
                            <table>
                                <thead className="admin">
                                <tr>
                                    <th>Produits facturables</th>
                                    <th>Prix de vente à l'agence par défaut</th>
                                    <th>Reversement au réseau par défaut</th>
                                    <th>Prix de vente client conseillé</th>
                                    <th>Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {productList?.map(product => (
                                    <tr className={!product?.productEnabled && "deleted"}>
                                        <td>{product?.name}</td>
                                        <td>{product?.defaultPrice}</td>
                                        <td>{product?.defaultPercent}</td>
                                        <td>{product?.advisedResellPrice}</td>
                                        <td className="actions">
                                            <div>
                                                <i className="fa fa-pen-to-square"
                                                   onClick={() => handleFormProductModal(product?.id)}/>
                                                <i onClick={() => handleDeleteProduct(product?.id)}
                                                   className="fa fa-trash"/>
                                                <i
                                                    id={product?.id}
                                                    className={product["productEnabled"] ? "fa fa-eye" : "fa fa-eye-slash"}
                                                    onClick={handleProductEnable}
                                                    title={product["productEnabled"] ? "Produit visible - Cliquer pour masquer" : "Produit masqué - Cliquer pour rendre visible"}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <PagingDashboard location={"Produits facturables"} />
                        </div>
                    </div>

            </div>
        </main>
    )
}
